import { EventMeta } from '../../../interfaces/meta.interface';

const move: EventMeta = {
    title: 'Message Moved',
    default: {
        description: 'Message Moved',
        longDescription: 'A message was moved to another folder.',
        severity: 'info',
    },
};

export default move;
